import SidebarAuthHeader from './view';

export default SidebarAuthHeader;
